import {FC} from 'react'
import {ArrowIcon} from '../SvgIcon'

export const TrialFooter: FC = () => {
  return (
    <div className="bg-trial karla w-full h-12 flex justify-center items-center text-white text-base border-t border-gray-500 hidden">
      You have 30 days remaining in your trial.
      <span className="ml-3 text-red-500">Activate Now</span>
      <ArrowIcon classes="ml-2" strokeColor="text-red-600" strokeWidth={0.1} />
    </div>
  )
}
